import { UseFormReset } from 'react-hook-form';
import { BlacklistFormValues, BlacklistSettings } from '../../types';

interface EnableAllProps {
  getValues: () => BlacklistFormValues;
  defaultSettings: BlacklistSettings;
  allSettingsEnabled: boolean;
  setAllSettingsEnabled: (data: boolean) => void;
  reset: UseFormReset<BlacklistFormValues>;
  setSettings: (data: BlacklistSettings) => void;
}

const enableAll = ({
  getValues,
  defaultSettings,
  allSettingsEnabled,
  setAllSettingsEnabled,
  reset,
  setSettings,
}: EnableAllProps) => {
  const fields = getValues();

  let data = { ...fields };

  const nextDefaultSettings = { ...defaultSettings };

  if (allSettingsEnabled) {
    Object.keys(defaultSettings).forEach((key) => {
      nextDefaultSettings[key as keyof BlacklistSettings] = false;
    });

    data = {
      ...data,
      ...nextDefaultSettings,
    };
  } else {
    nextDefaultSettings.corporateClients = true;
    nextDefaultSettings.individualClients = true;
    nextDefaultSettings.transactionsCorporateClients = true;
    nextDefaultSettings.transactionsIndividualClients = true;
    nextDefaultSettings.transactionsCorporatePayersPayees = true;
    nextDefaultSettings.transactionsIndividualPayersPayees = true;
    nextDefaultSettings.transactionsCounterpartiesBanks = true;
    nextDefaultSettings.paymentOrderPayersPayees = true;

    data = {
      ...data,
      ...nextDefaultSettings,
    };
  }

  setAllSettingsEnabled(!allSettingsEnabled);
  reset(data);
  setSettings(nextDefaultSettings);
};

export default enableAll;
